<template>
    <ac-modal :title="title" ref="modal">
        <div class="info-board info-board-blue">
            The plans below are part of a shared offering that can be edited 
            <a @click.prevent="goToPlanOffering">here</a>
        </div>
        <br/>
        <div v-if="widgetReady">
            <view-plans :consultantId="consultantId" :planPoolId="planPoolId">

            </view-plans>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../../global/framework/api.js";
    import {common} from "../../../../global/common.js";
    import ViewPlans from './ViewPlans.vue';

    export default {
        name: "ViewPlansModal",
        components: {ViewPlans},
        data() {
            return {
                widgetReady: false,
                consultantId: null,
                planPoolId: null,
            };
        },
        computed: {
            title() {
                return "Group Offering"
            },
        },
        async mounted() {

        },
        methods: {
            async showModal({ consultantId, planPoolId }) {
                this.widgetReady = false;
                this.consultantId = consultantId;
                this.planPoolId = planPoolId;
                this.widgetReady = true;
                this.$refs.modal.open();
            },
            goToPlanOffering() {
                let args = {consultantId: this.consultantId, planPoolId: this.planPoolId};
                this.$router.push({name: "editPlanOffering", params: args});
            },
        },
    }
</script>

<style scoped>

</style>